import { sortDuckCreator } from 'axl-ducks';
import { pageNames } from '@atc/bonnet-paths';

export default sortDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    initialState: 'derivedpriceASC',
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
